module.exports = __webpack_public_path__ + "img/step5.57b3c1ab.png";